<template>
  <div
    class="max-w-screen-xl mx-auto px-4"
    data-testid="landing-page-locations-section"
  >
    <h2
      class="mb-0 uppercase"
      :class="{
        'text-center': component?.layout === 'center',
        'text-end': component?.layout === 'right',
      }"
    >
      {{ component.title }}
    </h2>
    <common-md-content
      v-if="component.subText"
      v-once
      v-slot="{ renderedContent }"
      :content="component.subText"
    >
      <div
        :class="{
          'text-center': component?.layout === 'center',
          'text-end': component?.layout === 'right',
        }"
        v-html="renderedContent"
      ></div>
    </common-md-content>
    <div class="mt-8 text-center">
      <strapi-image
        :image-class="`${fullWidth ? 'w-full' : ''}`"
        :alt="component.title"
        :image="component.image"
        fluid
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StrapiLocationsMap } from '~/apollo/types/types';

withDefaults(
  defineProps<{
    fullWidth?: boolean;
    component: StrapiLocationsMap;
  }>(),
  {
    fullWidth: false,
  },
);
</script>
